import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconSquareBehindSquare2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-outlined-radius-3-stroke-1.5-IconSquareBehindSquare2"><Path d="M8.75 8.75V5C8.75 3.75736 9.75736 2.75 11 2.75H19C20.2426 2.75 21.25 3.75736 21.25 5V13C21.25 14.2426 20.2426 15.25 19 15.25H15.25M13 8.75H5C3.75736 8.75 2.75 9.75736 2.75 11V19C2.75 20.2426 3.75736 21.25 5 21.25H13C14.2426 21.25 15.25 20.2426 15.25 19V11C15.25 9.75736 14.2426 8.75 13 8.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconSquareBehindSquare2;
